import type { InspectionShotKey } from '@carvia/ros-client-types';
import { useI18n } from 'vue-i18n';
import type { FuelType } from '@/entities/cars/fuel-type.enum';
import { getShotHintKey, getShotLabelKey } from './inspection-shots';

/** Labels for Inspection shots; unknown keys from older catalogs fall back to the raw key. */
export function useShotLabel() {
  const { t, te } = useI18n({ useScope: 'global' });

  const getShotLabel = (shotKey: InspectionShotKey, fuelType?: FuelType | null) => {
    const key = getShotLabelKey(shotKey, fuelType);
    return te(key) ? t(key) : shotKey;
  };

  const getShotHint = (shotKey: InspectionShotKey) => {
    const key = getShotHintKey(shotKey);
    return te(key) ? t(key) : '';
  };

  return { getShotLabel, getShotHint };
}
